import React from "react";
import { useLang } from "../i18n/LanguageContext";
import SectionHeading from "../components/site/SectionHeading";
import { IMG } from "../lib/media";

const items = [
  { img: IMG.kitchen, title: "Uptown Dallas · Kitchen Remodel", tag: "Kitchen" },
  { img: IMG.bathroom, title: "Plano · Master Bathroom", tag: "Bathroom" },
  { img: IMG.livingRoom, title: "Highland Park · Living Room", tag: "Full Remodel" },
  { img: IMG.exterior, title: "North Dallas · Exterior Painting", tag: "Painting" },
  { img: IMG.flooring, title: "Frisco · LVP Flooring", tag: "Flooring" },
  { img: IMG.cabinet, title: "Addison · Custom Cabinets", tag: "Cabinets" },
  { img: IMG.tile, title: "Carrollton · Tile Replacement", tag: "Tile" },
  { img: IMG.drywall, title: "Richardson · Drywall Repair", tag: "Drywall" },
  { img: IMG.commercial, title: "Deep Ellum · Commercial Office", tag: "Commercial" },
];

const Portfolio = () => {
  const { t } = useLang();
  return (
    <div data-testid="page-portfolio">
      <section className="pt-40 pb-20 border-b border-white/5">
        <div className="container-x">
          <SectionHeading overline={t.gallery.overline} title={t.gallery.title} subtitle={t.gallery.subtitle} />
        </div>
      </section>

      <section className="section-y">
        <div className="container-x grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => (
            <figure
              key={i}
              className="before-after hairline rounded-xl overflow-hidden bg-[#141417] group"
              data-testid={`portfolio-item-${i}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img src={it.img} alt={it.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="text-[10px] tracking-[0.2em] uppercase px-2.5 py-1 rounded-full border border-white/25 bg-black/30 backdrop-blur">
                    {it.tag}
                  </span>
                </div>
                <figcaption className="absolute bottom-5 left-5 right-5">
                  <div className="font-display text-lg text-white">{it.title}</div>
                  <div className="text-xs text-white/60 mt-1">GA Signature · Dallas, TX</div>
                </figcaption>
              </div>
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
